import { BaseMutations } from '@/store/base-mutations';
import { DataPilot } from '@/modules/data-pilot/types';
import { ProductState } from './state';

export default class ProductMutations extends BaseMutations<ProductState> {
  SET_EVENTS(events: DataPilot.Event[]) {
    this.state.events = events;
  }

  TOGGLE_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }

  SET_PRODUCTS(products: DataPilot.Device[]) {
    this.state.products = products;
  }
}
